"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _core = require("@popperjs/core"),
    _clickOutside = _interopRequireDefault(require("click-outside")),
    _Button = _interopRequireDefault(require("../Button"));

require("./_menu-button.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var ALLOWED_ALIGN = ["start", "end"];

function Menu(a) {
  var b = a.children,
      c = a.open,
      d = a.align,
      e = a.id;
  return c ? _react["default"].createElement("div", {
    id: e,
    className: (0, _classnames["default"])("menu-button__menu", {
      "menu-button_menu--right-align": "right" === d
    })
  }, b) : null;
}

function toggleMenu(a, b) {
  return function () {
    b(_objectSpread(_objectSpread({}, a), {}, {
      menuOpen: !a.menuOpen
    }));
  };
}

function MenuButton(a) {
  var b = a.children,
      c = a.buttonProps,
      d = a.align,
      e = a.id,
      f = a.customButton,
      g = (0, _react.useState)({
    menuOpen: !1,
    unbindListener: void 0
  }),
      h = (0, _slicedToArray2["default"])(g, 2),
      i = h[0],
      j = h[1],
      k = "".concat(e, "-btn"),
      l = "".concat(e, "-menu"),
      m = ALLOWED_ALIGN.includes(d) ? d : "end",
      n = toggleMenu(i, j),
      o = i.menuOpen,
      p = i.unbindListener;
  return (0, _react.useEffect)(function () {
    var a = document.getElementById(k),
        b = document.getElementById(l);
    b && a && ((0, _core.createPopper)(a, b, {
      placement: "bottom-".concat(m),
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, 10]
        }
      }]
    }), b.style.opacity = "1");
  }, [o, d, e, b]), (0, _react.useEffect)(function () {
    if (o || p) {
      if (!o && p) return void p();
      var a = document.getElementById(e);
      j({
        menuOpen: o,
        unbindListener: (0, _clickOutside["default"])(a, n)
      });
    }
  }, [o]), _react["default"].createElement("div", {
    id: e,
    className: "menu-button"
  }, f ? _react["default"].createElement("div", {
    id: k
  }, _react["default"].cloneElement(f, {
    onClick: n,
    id: k
  })) : _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, c, {
    id: k,
    type: "TERTIARY",
    onClick: n,
    hasMenuIcon: !0
  })), _react["default"].createElement(Menu, {
    id: l,
    open: o,
    align: d
  }, b));
}

var _default = MenuButton;
exports["default"] = _default;